<img [lazyBildelasting]="informasjon().forsideUrl" alt="Forsidebilde" data-testid="dokument-forsidebilde">
